module.exports = __webpack_public_path__ + "static/media/bg_winner_screen.410715cd.png";